import { datagridProps } from "../common";
import ListDetail from "../../components/ListDetail";
import panelCategoryForm from "../../dtos/forms/panel/Category";
import panelForm from "../../dtos/forms/panel";
import { api } from "@cetma/skeleton-app/index";
import { ConfirmDialogLabel } from "@cetma/skeleton-app/components/ConfirmDialog";
import { FormLabel } from "@cetma/skeleton-app/components/Crud/Form";
import { translate } from "@cetma/skeleton-app/util";
import { TableLabel } from "@cetma/skeleton-app/components/Crud/Table";

export default function PanelCategory() {

    const confirmDialogLabel: ConfirmDialogLabel = {
        title: translate('confirmDialog.title'),
        text: translate('confirmDialog.text'),
        confirm: translate('confirmDialog.confirm'),
        cancel: translate('confirmDialog.cancel')
    };

    const formLabel: FormLabel = {
        edit: translate('form.edit'),
        entity: translate('panel'),
        new: translate('form.new'),
        reset: translate('form.reset'),
        save: translate('form.save')
    };

    const tableLabel: Partial<TableLabel> = {
        delete: translate('table.delete'),
        deleteRows: translate('table.deleteRows'),
        add: translate('table.add'),
        edit: translate('table.edit'),
        close: translate('table.close'),
        refresh: translate('table.refresh'),
        noRowsLabel: translate('table.noRowsLabel')
    }

    return (
        <ListDetail 
            api={api}
            listEntity={{name: 'panelCategory', label: 'Panel cateogry'}}
            listForm={panelCategoryForm}
            detailEntity={{name: 'panel', label: 'panel', select: ['panelId', 'panelName', 'panelImg']}}
            detailForm={panelForm}
            datagridProps={datagridProps}
            formLabel={formLabel}
            tableLabel={tableLabel}
            confirmDialogLabel={confirmDialogLabel}
            joinField="panelCategoryId"
        />
    )
}